import Vue from 'vue';
import ViewUI from 'view-design';
import i18n from '@/locales/index';

// Vue.use(ViewUI, {
//     capture: false,
//     i18n: (key, value) => i18n.t(key, value)
// });

Vue.use(ViewUI, {
    capture: false,
    i18n(path, options) {
        const value = i18n.t(path, options);
        if (value !== null && value !== undefined) {
            return value;
        }
        return '';
    },
});
